/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconActivity = createReactComponent("outline", "activity", "IconActivity", [["path", { "d": "M3 12h4l3 8l4 -16l3 8h4", "key": "svg-0" }]]);

export { IconActivity as default };
//# sourceMappingURL=IconActivity.mjs.map
